<template>
  <div class="entrance-exam">
    <h1>Opptaksprøve</h1>
    <p>prøve prøve</p>
    <div class="accordian-container">
      <div class="accordian-flex">
        <p class="align-left">Trykk her for å se hele oppgaven</p>
        <p class="align-right" @click="toggleAccordian()" v-if="!isOpen">&gt;</p>
        <p class="align-right" @click="toggleAccordian()" v-else>&lt;</p>
      </div>
      <EntranceVideo v-if="isOpen" />
    </div>
    <div style="clear: both"></div>
    <SubmissionBar/>
    <FeedbackBar/>
  </div>
</template>

<script>
import SubmissionBar from "@/components/SubmissionBar.vue";
import EntranceVideo from "@/components/EntranceVideo.vue";
import FeedbackBar from "@/components/FeedbackBar.vue";
export default {
  name: "EntranceExam",
  data() {
    return {
      isOpen: false,
    };
  },
  components: {
    EntranceVideo,
    SubmissionBar,
    FeedbackBar,
  },
  methods: {
    toggleAccordian() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  padding-bottom: 20px;
}
.align-left {
  float: left;
}
.align-right {
  float: right;
}
.accordian-container {
  display: flex;
  flex-direction: column;
  min-height: 1.5em;
  width: 100%;
  background-color: var(--secondary-background-color);
  & > a {
    justify-content: center;
  }
}
.accordian-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>